// Static data constants for reuse across components

export const UNITS = [
  'Kg', 'Grams', 'Tonnes', 'Pieces', 'Meters', 'Liters', 'Square Meters', 'Square Feet'
] as const;

export const SHAPES = [
  'Round', 'Square', 'Rectangular', 'Hexagonal', 'Flat', 'Tube', 'Angle'
] as const;

export const TYPES = [
  'Goods', 'Services'
] as const;

export const FINISHING_TYPES = [
  'Polished', 'Anodized', 'Coated', 'Heat Treated', 'Galvanized', 'Painted', 'Raw'
] as const;

// Type definitions for better type safety
export type Unit = typeof UNITS[number];
export type Shape = typeof SHAPES[number];
export type Type = typeof TYPES[number];
export type FinishingType = typeof FINISHING_TYPES[number];

// Workers and Machines data for reuse across components
export const PACKING_WORK_AREA_ID = 11;

export const WORKERS = [
  { id: '1', name: 'John Doe' },
  { id: '2', name: 'Jane Smith' },
  { id: '3', name: 'Mike Johnson' },
  { id: '4', name: 'Sarah Wilson' },
  { id: '5', name: 'David Brown' },
  { id: '6', name: 'Lisa Davis' },
  { id: '7', name: 'Robert Miller' },
  { id: '8', name: 'Emily Garcia' }
] as const;

export const MACHINES = [
  { id: '1', name: 'Machine A1' },
  { id: '2', name: 'Machine B2' },
  { id: '3', name: 'Machine C3' },
  { id: '4', name: 'Machine D4' },
  { id: '5', name: 'Machine E5' },
  { id: '6', name: 'Machine F6' }
] as const;

export const SHIFTS = ['MORNING', 'AFTERNOON', 'NIGHT'] as const;

// Type definitions for workers and machines
export type Worker = typeof WORKERS[number];
export type Machine = typeof MACHINES[number];
export type Shift = typeof SHIFTS[number];
